import type { ElectionType } from '../../../../types/followUp'

/** "Turnout likelihood" reads the primary model for a Primary election. */
export function propensityLabel(type: ElectionType | null | undefined): string {
  return type === 'Primary' ? 'Primary turnout likelihood' : 'Turnout likelihood'
}
